import React from "react";
import { Trash2, FolderOpen, Copy } from "lucide-react";
import { fmt } from "../lib/framing";
import { Button } from "./ui/button";

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

const LAYER_LABEL = { 0: "no mat", 1: "single", 2: "double", 3: "triple" };

export const SavedCalculations = ({ items, onLoad, onDelete, onDuplicate, canDuplicate, query }) => {
  if (!items.length) {
    return (
      <p data-testid="saved-empty" className="px-1 py-6 text-sm text-muted-foreground">
        {query ? (
          `No saved jobs match “${query}”.`
        ) : (
          "No saved calculations yet. Compute a frame or an artwork size and hit Save to keep it here."
        )}
      </p>
    );
  }
  return (
    <div data-testid="list-saved-calculations">
      {/* header */}
      <div className="grid grid-cols-[1fr_auto_auto_auto] items-center gap-3 border-b border-border pb-2 text-[11px] font-semibold uppercase tracking-[0.05em] text-muted-foreground">
        <span>Reference</span>
        <span className="text-right">Frame size</span>
        <span className="text-right">Saved</span>
        <span></span>
      </div>
      <ul className="divide-y divide-border">
        {items.map((c) => (
          <li
            key={c.id}
            data-testid={`saved-row-${c.id}`}
            className="group grid grid-cols-[1fr_auto_auto_auto] items-center gap-3 py-3 transition-colors hover:bg-slate-50"
          >
            <div className="min-w-0">
              <p className="truncate font-medium text-foreground">{c.name}</p>
              <p className="truncate text-xs text-muted-foreground">
                {LAYER_LABEL[c.result?.mat_layers] ?? ""} · {c.result?.rule?.replace("_", " ")}
              </p>
            </div>
            <span className="whitespace-nowrap text-right font-mono text-sm text-foreground">
              {fmt(c.result?.outer_width, c.result?.unit)} × {fmt(c.result?.outer_height, c.result?.unit)}
              <span className="ml-1 text-xs text-muted-foreground">{c.result?.unit}</span>
            </span>
            <span className="whitespace-nowrap text-right text-xs text-muted-foreground">{fmtDate(c.created_at)}</span>
            <div className="flex shrink-0 items-center gap-1">
              <Button data-testid={`load-calc-${c.id}`} variant="ghost" size="sm" className="h-8 px-2 text-primary" onClick={() => onLoad(c)}>
                <FolderOpen className="mr-1 h-4 w-4" /> Load
              </Button>
              {canDuplicate && (
                <Button data-testid={`duplicate-calc-${c.id}`} variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-primary" title="Duplicate" onClick={() => onDuplicate(c)}>
                  <Copy className="h-4 w-4" />
                </Button>
              )}
              <Button data-testid={`delete-calc-${c.id}`} variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-destructive" onClick={() => onDelete(c.id)}>
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
